// Copyright (c) 2018 Deere & Company

import PartRequestForm from '../state/part-request-form';
import actions from '../actions-list';
import {hasAccess} from '../../../shared/services/security';
import {isEditable} from '../services/return-status';
import moment from 'moment/moment';

export const updatePartRequestForm = partReturn =>

    (dispatch, getState) => {

        let dispatchDate;

        dispatchDate = partReturn.dispatchDate;

        if (!partReturn.dispatchDate && isEditable(partReturn) && hasAccess(getState().user.security, 'PART_RETURNS_EDIT', 'PART_RETURNS_EDIT')) {

            dispatchDate = moment.utc().startOf('day').valueOf();

        }

        dispatch({
            partRequestForm: new PartRequestForm({
                courierInfo: partReturn.courierInfo,
                dispatchDate,
                returnStatus: partReturn.allowedReturnStatuses.findIndex(item => item.id === partReturn.returnStatus.id) > -1 ?
                    partReturn.returnStatus :
                    partReturn.allowedReturnStatuses[0]
            }),
            type: actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM
        });

    };

export const updatePartRequestFormComments = comments => ({
    comments,
    type: actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COMMENTS
});

export const updatePartRequestFormCourierName = courierName => ({
    courierName,
    type: actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COURIER_NAME
});

export const updatePartRequestFormDispatchDate = dispatchDate => ({
    dispatchDate,
    type: actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_DISPATCH_DATE
});

export const updatePartRequestFormReturnStatus = returnStatus => ({
    returnStatus,
    type: actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_RETURN_STATUS
});

export const updatePartRequestFormTrackingNumber = returnTrackingNumber => ({
    returnTrackingNumber,
    type: actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_TRACKING_NUMBER
});



// WEBPACK FOOTER //
// ./src/part-requests/request-details/action-creators/part-request-form.js